import { configureStore, combineReducers, } from "@reduxjs/toolkit";
import { ICommonModel } from "./commonReducer";
import { IDiseaseModel } from "./diseaseReducer";
import { ISimulationModel } from "./simulationReducer";
import { IQuantisModel } from "./quantisReducer";
import { ILightningModel } from "./lightningReducer";
import { IClimateShiftModel } from "./climateShiftReducer";
import { IWeevilTrakModel } from "./weevilTrakReducer";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas/rootSaga";
import commonReducer from "./commonReducer";
import diseaseReducer from "./diseaseReducer";
import simulationReducer from "./simulationReducer";
import quantisReducer from "./quantisReducer";
import lightningReducer from "./lightningReducer";
import climateShiftReducer from "./climateShiftReducer";
import weevTrakReducer from "./weevilTrakReducer";
import thunk from "redux-thunk";

const sagaMiddleWare = createSagaMiddleware();

const rootReducer = combineReducers({
    commonReducer,
    diseaseReducer,
    simulationReducer,
    quantisReducer,
    lightningReducer,
    climateShiftReducer,
    weevTrakReducer,
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDedaultMiddleware) => getDedaultMiddleware().concat([thunk, sagaMiddleWare])
});

sagaMiddleWare.run(rootSaga);

export type RootState = {
    commonReducer: ICommonModel,
    diseaseReducer: IDiseaseModel,
    simulationReducer: ISimulationModel,
    quantisReducer: IQuantisModel,
    lightningReducer: ILightningModel,
    climateShiftReducer: IClimateShiftModel,
    weevTrakReducer: IWeevilTrakModel,
};

export default store;